module.exports = __webpack_public_path__ + "img/no-goods.d24a7bce.png";